import { useEffect, useState } from "react";
import ResponsableUsoForm from "./ResponsableUsoForm";

const initialValues = {
    cuitResponsable: "",
    numeroAutorizacionIndividual: "",
    numeroPermisoHabilitante: "",
    matriculaProfesional: "",
    fechaExpedicion: null,
    fechaVencimiento: null,
};

const ResponsableUseFormContainer = ({ open, handleClose, handleSubmit, values }) => {
    const [formInitialValues, setFormInitialValues] = useState();

    useEffect(() => {
        if (values) {
            setFormInitialValues({
                ...values,
                cuitResponsable: (values.cuitResponsable || "").replace(/[-\s]/g, "")
            });
        } else {
            setFormInitialValues(initialValues)
        }
    }, [values])

    return (
        <ResponsableUsoForm
            open={open}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            values={formInitialValues}
        />
    )
}


export default ResponsableUseFormContainer;